import React, { useEffect, useState } from 'react';
import {
  getTimezoneDate,
  isTeamDefined,
  translate,
} from '../../../../utils/mundialUtils';
import { getNationPlaceholder, getStatusMatch } from '../../utils/utils';
//-------------------------------------------------------------------------
import BracketActionButton from '../BracketActionButton';
import { FlagPlaceholder } from '../FlagPlaceholder';
import NationFlag from '../NationFlag';
import './style.scss';

export const MatchDetails = ({ match, roundId, translations }) => {
  const [dateConfig, setDateConfig] = useState({ date: '', day: '', hour: '' });

  useEffect(() => {
    setDateConfig(getTimezoneDate(match.dateAndTimeInfo.scheduledStartTimeUTC));
  }, []);

  return (
    <div className="match-details">
      <span className="match-details__status">
        {getStatusMatch(match?.status?.scheduleStatus, translations)}
      </span>
      <div className="match-details__date">
        <span className="match-details__date__day">{dateConfig.day}</span>
        <span className="match-details__date__full-date">
          {dateConfig.date}{' '}
          {translate('matches_result_separatorPipe_label', translations)}{' '}
          {dateConfig.hour} hs
        </span>
      </div>
      <div className="match-details__match">
        {isTeamDefined(match?.homeParticipant) ? (
          <NationFlag
            urlFlag={match?.homeParticipant?.nationality?.images?.flag}
            nationName={match?.homeParticipant.names.default}
            score={match?.state?.homeScore}
            translations={translations}
          />
        ) : (
          <FlagPlaceholder
            textContent={match?.homeParticipant.names.default}
          />
        )}
        <span className={'match-details__match__vs'}>
          {translate('matches_result_separatorVersus_label', translations)}
        </span>
        {isTeamDefined(match?.awayParticipant) ? (
          <NationFlag
            urlFlag={match?.awayParticipant?.nationality?.images?.flag}
            nationName={match?.awayParticipant.names.default}
            score={match?.state?.awayScore}
            translations={translations}
          />
        ) : (
          <FlagPlaceholder
            textContent={match?.awayParticipant.names.default}
          />
        )}
      </div>
      <div className="match-details-action">
        <BracketActionButton
          status={match?.status?.scheduleStatus}
          defined={isTeamDefined(match?.homeParticipant) && isTeamDefined(match?.awayParticipant)}
          matchId={match.id}
          translations={translations}
          awayName={match?.awayParticipant.names.full}
          homeName={match?.homeParticipant.names.full}
        />
      </div>
    </div>
  );
};
